export interface TickerItem {
  id: string;
  time: string;
  text: string;
  tag: string;
}

export const tickerItems: TickerItem[] = [
  { id: "t1", time: "今天 09:20", text: "二楼烧腊档蜜汁叉烧今日提前售罄，想吃的建议明天十点前到", tag: "探店快讯" },
  { id: "t2", time: "今天 08:05", text: "早餐外卖横评更新：三家现磨豆浆浓度实测数据已录入", tag: "测评更新" },
  { id: "t3", time: "昨天 21:40", text: "老巷馄饨摊本周新增虾籽拌面，晚间排队约 25 分钟", tag: "探店快讯" },
  { id: "t4", time: "昨天 16:12", text: "69 元自热火锅六盒组合开箱完成，宽粉易糊底已记入提示", tag: "开箱记录" },
  { id: "t5", time: "前天 11:30", text: "奶油小方烘焙室盐可颂上新日调整为每周二、五", tag: "探店快讯" },
  { id: "t6", time: "前天 10:00", text: "「蒜香黄油虾仁意面」家常复刻教程浏览量突破 1.2 万", tag: "人气内容" },
];